import { NgModule } from '@angular/core';
import { CommonModule, registerLocaleData } from '@angular/common';
import { BreadcrumbComponent } from './component/breadcrumb/breadcrumb.component';
import { NzBreadCrumbModule } from 'ng-zorro-antd/breadcrumb';
import { NzIconModule } from 'ng-zorro-antd/icon';
import { NzSwitchModule } from 'ng-zorro-antd/switch'
import { DirectivesModule } from './directives/directives.module'
import { NzInputNumberModule } from 'ng-zorro-antd/input-number';
import { CsSelectCustomComponent } from './component/cs-select-custom/cs-select-custom.component';
import { NzTableModule } from 'ng-zorro-antd/table';
import { NzDividerModule } from 'ng-zorro-antd/divider';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { AvatarTextComponent, ExcelEditorModule, FormGenerateModule, ImageModule, NotificationModule, PermissionModule, PipeModule, TableModule, TreeComponent, TreeModule, UploadModule, VssUiConfig, VssUiControlsModule, VssUiDirectivesModule } from 'projects/vss-ui/src/public-api';
import { NzInputModule } from 'ng-zorro-antd/input';
import { NzSelectModule } from 'ng-zorro-antd/select';
import { NzModalModule } from 'ng-zorro-antd/modal';
import { NzCardModule } from 'ng-zorro-antd/card';
import { NzFormModule } from 'ng-zorro-antd/form';
import { NzCheckboxModule } from 'ng-zorro-antd/checkbox';
import { NzButtonModule } from 'ng-zorro-antd/button';
import { NzResizableModule } from 'ng-zorro-antd/resizable';
import { NzToolTipModule } from 'ng-zorro-antd/tooltip';
import { NzDropDownModule } from 'ng-zorro-antd/dropdown';
import { NzPopoverModule } from 'ng-zorro-antd/popover';
import { NzTagModule } from 'ng-zorro-antd/tag';
import { NzBadgeModule } from 'ng-zorro-antd/badge';
import { NzProgressModule } from 'ng-zorro-antd/progress';
import { NzEmptyModule } from 'ng-zorro-antd/empty';
import { NzPopconfirmModule } from 'ng-zorro-antd/popconfirm';
import { NzDatePickerModule } from 'ng-zorro-antd/date-picker';
import { NzUploadModule } from 'ng-zorro-antd/upload'
import { NzRadioModule } from 'ng-zorro-antd/radio'
import { NzTabsModule } from 'ng-zorro-antd/tabs'
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TreeConditionsV2Component } from './component/tree-conditions-v2/tree-conditions-v2.component';
import { DatePickerComponent } from './component/cs-date-picker/cs-date-picker.component';
import { NzSpinModule } from 'ng-zorro-antd/spin';
import { NzAlertModule } from 'ng-zorro-antd/alert';
import { CsRenderErrorsComponent } from './component/cs-render-errors/cs-render-errors.component';
import { CsTreeConditionsV3Component } from './component/cs-tree-conditions-v3/cs-tree-conditions-v3.component';
import { AlertComponent } from './component/alert/alert.component';
import { HeaderComponent } from './component/header/header.component';
import { DrodownModule } from 'projects/vss-ui/src/vss-ui/modules/drodown/drodown.module';
import { TreeViewComponent } from './component/tree-graph/tree-graph.component'
import { NotificationPopupComponent } from './component/notification-popup/notification-popup.component'
import { TreeSmosComponent } from './component/tree-smos/tree-smos.component';
import { NzTreeModule } from 'ng-zorro-antd/tree';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { CsTableComponent } from './component/table/table.component';
import { CsPaginationComponent } from './component/cs-pagination/cs-pagination.component';
import { CsSelectTableComponent } from './component/cs-select-table/cs-select-table.component';
import { SetupVssUiConfig } from '@app/classes/setup-vss-ui-config';
import { VssUiConfigService } from '@app/classes/vss-ui-config-service';
import { DragDropModule } from '@angular/cdk/drag-drop';
import { NzPaginationModule } from 'ng-zorro-antd/pagination';
import { NzCollapseModule } from 'ng-zorro-antd/collapse'
import { AddContractComponent } from "@appModules/shares/component/modal/add-contract/add-contract.component";
import {
  AddCertificationComponent
} from "@appModules/shares/component/modal/add-certification/add-certification.component";
import { CommonPlayerListComponent } from './component/common-player-list/common-player-list.component';
import { CommonCoachListComponent } from './component/common-coach-list/common-coach-list.component';
import { TableFormComponent } from './component/table-form/table-form.component';
import { PlayerPositionDropdownComponent } from './component/player-position-dropdown/player-position-dropdown.component';
import { TounamentDropdownComponent } from './component/tounament-dropdown/tounament-dropdown.component';
import { TrainingClassDropdownComponent } from './component/training-class-dropdown/training-class-dropdown.component';
import { LessonDropdownComponent } from './component/lesson-dropdown/lesson-dropdown.component';
import { CoachListDropdownComponent } from './component/coach-list-dropdown/coach-list-dropdown.component';
import { ClubDropdownComponent } from './component/club-dropdown/club-dropdown.component';
import { ProfileComponent } from './component/header/profile/profile.component';
import { SettingComponent } from './component/header/setting/setting.component';
import vi from '@angular/common/locales/vi';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';

registerLocaleData(vi);
export function HttpLoaderFactory(http: HttpBackend) {
  return new TranslateHttpLoader(new HttpClient(http), '../assets/locales/', '.json')
}

@NgModule({
  declarations: [
    BreadcrumbComponent,
    HeaderComponent,
    CsSelectCustomComponent,
    TreeConditionsV2Component,
    TreeSmosComponent,
    DatePickerComponent,
    CsRenderErrorsComponent,
    CsTreeConditionsV3Component,
    AlertComponent,
    TreeViewComponent,
    NotificationPopupComponent,
    CsTableComponent,
    CsPaginationComponent,
    CsSelectTableComponent,
    AddContractComponent,
    AddCertificationComponent,
    CommonPlayerListComponent,
    CommonCoachListComponent,
    TableFormComponent,
    PlayerPositionDropdownComponent,
    TounamentDropdownComponent,
    TrainingClassDropdownComponent,
    LessonDropdownComponent,
    CoachListDropdownComponent,
    ClubDropdownComponent,
    ProfileComponent,
    SettingComponent
  ],
  imports: [
    CommonModule,
    NzBreadCrumbModule,
    NzIconModule,
    NzSwitchModule,
    DirectivesModule,
    NzInputNumberModule,
    NzTableModule,
    NzDividerModule,
    FormsModule,
    ReactiveFormsModule,
    PipeModule,
    NzInputModule,
    NzSelectModule,
    DirectivesModule,
    NzModalModule,
    NzCardModule,
    NzCheckboxModule,
    NzButtonModule,
    NzResizableModule,
    NzToolTipModule,
    NzDropDownModule,
    NzPopoverModule,
    NzTagModule,
    NzBadgeModule,
    NzInputNumberModule,
    NzEmptyModule,
    NzPopconfirmModule,
    PermissionModule,
    NotificationModule,
    NzDatePickerModule,
    NzSpinModule,
    NzAlertModule,
    VssUiControlsModule,
    NzTabsModule,
    DrodownModule,
    NzTreeModule,
    ImageModule,
    NzAvatarModule,
    DragDropModule,
    NzFormModule,
    VssUiDirectivesModule,
    NzProgressModule,
    NzPaginationModule,
    TranslateModule.forChild({
      defaultLanguage: 'vi',
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpBackend]
      },
      extend: true
    }),
    ReactiveFormsModule,
    NzCollapseModule,
    NzUploadModule,
    TableModule
  ],
  exports: [
    BreadcrumbComponent,
    HeaderComponent,
    DirectivesModule,
    NzInputNumberModule,
    NzSwitchModule,
    TableModule,
    PipeModule,
    NzCardModule,
    NzFormModule,
    NzCheckboxModule,
    VssUiDirectivesModule,
    NzInputModule,
    NzButtonModule,
    NzSelectModule,
    NzIconModule,
    PermissionModule,
    UploadModule,
    FormGenerateModule,
    ExcelEditorModule,
    FormsModule,
    NzUploadModule,
    CsSelectCustomComponent,
    TreeConditionsV2Component,
    TreeSmosComponent,
    DatePickerComponent,
    CsRenderErrorsComponent,
    NzSwitchModule,
    NotificationModule,
    NzRadioModule,
    NzToolTipModule,
    CsTreeConditionsV3Component,
    AlertComponent,
    DrodownModule,
    NzDropDownModule,
    NzProgressModule,
    VssUiControlsModule,
    NzTabsModule,
    TreeViewComponent,
    NotificationPopupComponent,
    CsTableComponent,
    CsPaginationComponent,
    CsSelectTableComponent,
    ReactiveFormsModule,
    NzTreeModule,
    NzResizableModule,
    NzCollapseModule,
    AddContractComponent,
    AddCertificationComponent,
    NzEmptyModule,
    CommonPlayerListComponent,
    NzTableModule,
    PlayerPositionDropdownComponent,
    TounamentDropdownComponent,
    TrainingClassDropdownComponent,
    LessonDropdownComponent,
    CoachListDropdownComponent,
    ClubDropdownComponent,
  ],
  providers: [
    {
      provide: VssUiConfig,
      useClass: SetupVssUiConfig,
      deps: [VssUiConfigService]
    },
  ]
})
export class SharesModule { }
